import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TestingStubPageComponent } from "./testing-stub-page/testing-stub-page.component";
import { VaCoreFormulabarComponent } from "./va-core-formulabar/va-core-formulabar.component";
import { FormulaBarModule } from "@va/core-library/formula-bar";
import { NzGridModule } from "ng-zorro-antd/grid";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GlobalSubheaderModule } from "../global-subheader/global-subheader.module";
import { FormulaBarComponent } from "./formula-bar/formula-bar.component";

const testingRoutes: Routes = [
  {
    path: "formula-bar",
    component: VaCoreFormulabarComponent,
    data: {
      title: "core formula bar testing",
    },
  },
  {
    path: "formula-bar-from-url",
    component: FormulaBarComponent,
    data: {
      title: "Formula Bar",
    },
  },
  {
    path: "",
    component: TestingStubPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(testingRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class TestingStubPageRoutingModule {}

@NgModule({
  declarations: [
    TestingStubPageComponent,
    VaCoreFormulabarComponent,
    FormulaBarComponent,
  ],
  imports: [
    CommonModule,
    TestingStubPageRoutingModule,
    GlobalSubheaderModule,
    FormsModule,
    NzGridModule,
    FormulaBarModule,
    ReactiveFormsModule,
  ],
})
export class TestingStubPageModule {}
